export default __webpack_public_path__ + "static/media/j2.defe2f1a.jpeg";